/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type PatientAuthorizationWarning = typeof PatientAuthorizationWarning[keyof typeof PatientAuthorizationWarning];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientAuthorizationWarning = {
  FutureEffective: 'FutureEffective',
  Expired: 'Expired',
  Exhausted: 'Exhausted',
  Unresolved: 'Unresolved',
  ServiceCodeNotCovered: 'ServiceCodeNotCovered',
} as const;
